import { captureException } from "@sentry/react";
import { Dispatch } from "redux";
import { AxiosInstance } from "axios";
import { showNotification } from "../../notification/actions";

import { SET_PLAN_COVER } from "../types";
import { PlanActionTypes } from "../models/planActions";
import { IStateTree } from "../../interfaces";
import { ICover } from "../../../pages/plan/MiddleRow/Image/interfaces";

export default (data: { cover: ICover, planId: string }, callback: (res: boolean) => void) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean }>("/change-plan-cover", data);
        dispatch({
            type: SET_PLAN_COVER,
            payload: { ...res, ...data },
        });
        if (callback) {
            callback(true);
        }
    } catch (error) {
        if (callback) {
            callback(false);
        }
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};
